// BDS CUSTOM: BCA Apparel size matrix — forked from tee-size-matrix.js.
// Deltas vs Cornwell:
// - Sizes S–5XL, NO per-size upcharges.
// - Tiers 25 / 50 / 100 → 5% / 10% / 15% (scoped to bca-apparel collection).
// - Cross-garment cart-aware math uses collection "bca-apparel" (tee + hoodie combined).
// - Left-chest chooser: "logo" (default, no fee) vs "business-name" (fee variant + props).
// - When business-name selected: fee variant (data-fee-variant-id) added with
//   quantity = total garments this page; matching line-item properties attached
//   to every garment line + the fee line. 25-piece combined minimum enforced at ATC.
// - Fee taper displayed at $5/$4/$3 for 1–24/25–49, 50–99, 100+ combined (handled
//   by automatic discounts on the fee product at checkout — this is the UX preview).

(function () {
  var BDS_BCA_SIZE_ORDER = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];

  var BDS_BCA_TIERS = [
    { min: 100, discount: 15, msg: function ()  { return '✅ 15% off unlocked — maximum discount!'; } },
    { min: 50,  discount: 10, msg: function (n) { return '✅ 10% off unlocked — add ' + (100 - n) + ' more for 15%'; } },
    { min: 25,  discount: 5,  msg: function (n) { return '✅ 5% off unlocked — add ' + (50 - n) + ' more for 10%'; } },
    { min: 0,   discount: 0,  msg: function (n) { return 'Add ' + (25 - n) + ' more to unlock 5% off'; } }
  ];

  // BDS CUSTOM: fee per piece in cents by combined qty. Mirrors the automatic
  // discounts on the fee product at checkout ($5 base → $4 at 50+, $3 at 100+).
  function bdsBcaFeeCentsPerPiece(combinedQty) {
    if (combinedQty >= 100) return 300;
    if (combinedQty >= 50)  return 400;
    return 500;
  }

  function bdsBcaGetTierMsg(total, tiersList) {
    for (var i = 0; i < tiersList.length; i++) {
      if (total >= tiersList[i].min) return tiersList[i].msg(total);
    }
    return '';
  }

  function bdsBcaGetUnlockedTier(total, tiersList) {
    for (var i = 0; i < tiersList.length; i++) {
      if (tiersList[i].min > 0 && total >= tiersList[i].min) return tiersList[i];
    }
    return null;
  }

  function bdsBcaGetNextTier(total, tiersList) {
    var upcoming = tiersList
      .filter(function (t) { return t.min > total; })
      .sort(function (a, b) { return a.min - b.min; });
    return upcoming[0] || null;
  }

  function bdsBcaFormatCents(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  var BDS_BCA_SIZE_LABELS = {
    S:  { singular: 'Small',  plural: 'Smalls'  },
    M:  { singular: 'Medium', plural: 'Mediums' },
    L:  { singular: 'Large',  plural: 'Larges'  },
    XL: { singular: 'XL',     plural: 'XLs'     }
  };

  function bdsBcaSizeLabel(size, qty) {
    var map = BDS_BCA_SIZE_LABELS[size];
    if (map) return qty === 1 ? map.singular : map.plural;
    return qty === 1 ? size : size + 's';
  }

  function bdsBcaBuildCalloutHtml(unlocked, next, combinedQty, discountCents, cartBcaQty, maxTierMin) {
    if (!next) {
      return (
        '<div class="siws-tee-summary__callout siws-tee-summary__callout--max">' +
          '<span class="siws-tee-summary__callout-icon">✅</span>' +
          '<div class="siws-tee-summary__callout-text">' +
            '<p class="siws-tee-summary__callout-primary">Maximum Tier Reached</p>' +
            '<p class="siws-tee-summary__callout-secondary">Saved ' + bdsBcaFormatCents(discountCents) + ' on this order</p>' +
          '</div>' +
        '</div>'
      );
    }

    var progressPct = Math.min((combinedQty / maxTierMin) * 100, 100);
    var remaining   = next.min - combinedQty;

    var cartContextLine = cartBcaQty > 0
      ? '<p class="siws-tee-summary__callout-cart-context">' + cartBcaQty + ' already in cart from other BCA Apparel garments</p>'
      : '';

    return (
      '<div class="siws-tee-summary__callout">' +
        '<span class="siws-tee-summary__callout-icon">↑</span>' +
        '<div class="siws-tee-summary__callout-text">' +
          '<p class="siws-tee-summary__callout-primary">Add ' + remaining + ' more for ' + next.discount + '% off</p>' +
          cartContextLine +
          '<div class="siws-tee-summary__callout-progress" ' +
               'style="display:block;width:100%;height:14px;' +
                      'background:#d1d5db;border-radius:7px;' +
                      'overflow:hidden;margin-top:8px;">' +
            '<div class="siws-tee-summary__callout-progress-bar" ' +
                 'style="display:block;height:14px;' +
                        'background:#16a34a;' +
                        'width:' + progressPct.toFixed(1) + '%;"></div>' +
          '</div>' +
          '<p class="siws-tee-summary__callout-progress-label">' + combinedQty + ' / ' + maxTierMin + '</p>' +
        '</div>' +
      '</div>'
    );
  }

  // Fetch /cart.js and sum quantities across line items whose product_id is in idsList.
  function bdsBcaFetchCartQty(idsList) {
    if (!idsList || !idsList.length) return Promise.resolve(0);
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (cart) {
        return (cart.items || [])
          .filter(function (item) { return idsList.indexOf(item.product_id) !== -1; })
          .reduce(function (sum, item) { return sum + item.quantity; }, 0);
      })
      .catch(function () { return 0; });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var matrix = document.getElementById('siws-tee-matrix');
    if (!matrix) return;

    var variantMap;
    try {
      variantMap = JSON.parse(matrix.dataset.variants);
    } catch (e) {
      console.error('BDS: failed to parse BCA variant map', e);
      return;
    }

    var variantPrices = null;
    try { variantPrices = JSON.parse(matrix.dataset.variantPrices); } catch (e) { variantPrices = null; }

    var bcaProductIds = null;
    try { bcaProductIds = JSON.parse(matrix.dataset.bcaProductIds); } catch (e) { bcaProductIds = null; }

    var feeVariantId = parseInt(matrix.dataset.feeVariantId, 10);
    var customMin    = parseInt(matrix.dataset.customMin, 10) || 25;

    var cartBcaQty = 0;

    var grid        = document.getElementById('siws-tee-grid');
    var summaryEl   = document.getElementById('siws-tee-summary');
    var errorEl     = document.getElementById('siws-tee-error');
    var atcBtn      = document.getElementById('siws-tee-atc-btn');
    var crossNoteEl = document.getElementById('siws-tee-cross-garment-note');

    var chestOpts    = document.querySelectorAll('input[name="bds-bca-chest"]');
    var imprintPanel = document.getElementById('bds-bca-imprint');
    var imprintName  = document.getElementById('bds-bca-imprint-name');
    var imprintPhone = document.getElementById('bds-bca-imprint-phone');
    var imprintErr   = document.getElementById('bds-bca-imprint-error');

    function bdsBcaGetChest() {
      for (var i = 0; i < chestOpts.length; i++) {
        if (chestOpts[i].checked) return chestOpts[i].value;
      }
      return 'logo';
    }

    function bdsBcaIsBusinessName() { return bdsBcaGetChest() === 'business-name'; }

    function bdsBcaSetChestVisibility() {
      var custom = bdsBcaIsBusinessName();
      imprintPanel.style.display = custom ? 'block' : 'none';
      [imprintName, imprintPhone].forEach(function (input) {
        if (input) input.disabled = !custom;
      });
      if (!custom && imprintErr) imprintErr.hidden = true;
      bdsBcaUpdateSummary();
    }

    chestOpts.forEach(function (r) { r.addEventListener('change', bdsBcaSetChestVisibility); });
    if (imprintName) {
      imprintName.addEventListener('input', function () {
        if (imprintErr && imprintName.value.trim().length > 0) imprintErr.hidden = true;
      });
    }

    // BDS CUSTOM: as-you-type phone formatter. Mirrors gift-card-picker.js's
    // formatPhone() (digits → "(XXX) XXX-XXXX") but runs on every keystroke,
    // and formats progressively so partial input reads naturally
    // ("(555", "(555) ", "(555) 555-", etc.). Cap at 10 digits.
    function bdsBcaFormatPhoneProgressive(raw) {
      var digits = String(raw || '').replace(/\D/g, '').slice(0, 10);
      if (digits.length === 0)  return '';
      if (digits.length < 4)    return '(' + digits;
      if (digits.length < 7)    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
      return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
    }
    if (imprintPhone) {
      imprintPhone.addEventListener('input', function () {
        var caretAtEnd = imprintPhone.selectionStart === imprintPhone.value.length;
        var formatted  = bdsBcaFormatPhoneProgressive(imprintPhone.value);
        if (formatted !== imprintPhone.value) {
          imprintPhone.value = formatted;
          if (caretAtEnd) {
            imprintPhone.setSelectionRange(formatted.length, formatted.length);
          }
        }
      });
    }

    // Render inputs per size.
    BDS_BCA_SIZE_ORDER.forEach(function (size) {
      if (!variantMap[size]) return;

      var cell = document.createElement('div');
      cell.className = 'siws-tee-matrix__cell';

      var label = document.createElement('label');
      label.className = 'siws-tee-matrix__label';
      label.htmlFor   = 'siws-tee-qty-' + size;
      label.textContent = size;

      var input = document.createElement('input');
      input.type        = 'number';
      input.id          = 'siws-tee-qty-' + size;
      input.className   = 'siws-tee-matrix__input';
      input.min         = '0';
      input.value       = '';
      input.placeholder = '0';
      input.dataset.size      = size;
      input.dataset.variantId = variantMap[size];
      input.setAttribute('inputmode', 'numeric');

      input.addEventListener('input',  bdsBcaUpdateSummary);
      input.addEventListener('change', bdsBcaUpdateSummary);
      input.addEventListener('blur', function () {
        if (input.value === '') input.placeholder = '0';
      });

      cell.appendChild(label);
      cell.appendChild(input);
      grid.appendChild(cell);
    });

    function bdsBcaGetTotal() {
      var total = 0;
      grid.querySelectorAll('.siws-tee-matrix__input').forEach(function (inp) {
        var v = parseInt(inp.value, 10);
        if (v > 0) total += v;
      });
      return total;
    }

    function bdsBcaBuildSizeRows() {
      var out = [];
      BDS_BCA_SIZE_ORDER.forEach(function (size) {
        var inp = grid.querySelector('[data-size="' + size + '"]');
        if (!inp) return;
        var qty = parseInt(inp.value, 10);
        if (!(qty > 0)) return;

        var priceCents = variantPrices ? variantPrices[size] : null;
        var lineCents  = priceCents != null ? priceCents * qty : null;
        var label      = bdsBcaSizeLabel(size, qty);

        var costCell = lineCents != null
          ? qty + ' × ' + bdsBcaFormatCents(priceCents) + ' = ' + bdsBcaFormatCents(lineCents)
          : qty + ' units';

        out.push(
          '<tr><td>(' + qty + ') ' + label + '</td>' +
          '<td class="screwdriver-summary__qty-cell">' + costCell + '</td></tr>'
        );
      });
      return out.join('');
    }

    function bdsBcaComputeSubtotal() {
      if (!variantPrices) return 0;
      var subtotal = 0;
      grid.querySelectorAll('.siws-tee-matrix__input').forEach(function (inp) {
        var qty = parseInt(inp.value, 10);
        if (!(qty > 0)) return;
        var priceCents = variantPrices[inp.dataset.size];
        if (priceCents != null) subtotal += priceCents * qty;
      });
      return subtotal;
    }

    function bdsBcaUpdateSummary() {
      var pageQty     = bdsBcaGetTotal();
      var combinedQty = pageQty + cartBcaQty;
      errorEl.style.display = 'none';
      if (crossNoteEl) crossNoteEl.hidden = true;

      if (pageQty === 0) {
        summaryEl.innerHTML =
          '<h4 class="screwdriver-summary__title" ' +
              'style="font-size:1.6rem;font-weight:700;' +
                     'color:rgba(var(--color-foreground),1);' +
                     'text-transform:none;letter-spacing:normal;' +
                     'margin:0 0 1rem;">Adding to Cart</h4>' +
          '<p class="siws-tee-summary__hint">' + bdsBcaGetTierMsg(0, BDS_BCA_TIERS) + '</p>';
        bdsBcaEnforceCustomMin();
        return;
      }

      if (!variantPrices) {
        summaryEl.innerHTML =
          '<h4 class="screwdriver-summary__title">Adding to Cart</h4>' +
          '<p class="siws-tee-summary__hint">Total: ' + pageQty + ' ' + (pageQty === 1 ? 'garment' : 'garments') + '</p>' +
          '<p class="siws-tee-summary__hint">' + bdsBcaGetTierMsg(combinedQty, BDS_BCA_TIERS) + '</p>';
        bdsBcaEnforceCustomMin();
        return;
      }

      var rows          = bdsBcaBuildSizeRows();
      var subtotalCents = bdsBcaComputeSubtotal();
      var unlocked      = bdsBcaGetUnlockedTier(combinedQty, BDS_BCA_TIERS);
      var next          = bdsBcaGetNextTier(combinedQty, BDS_BCA_TIERS);

      var discountPct   = unlocked ? unlocked.discount : 0;
      var discountCents = Math.round(subtotalCents * discountPct / 100);

      var tierBadgeText = unlocked
        ? '✅ ' + unlocked.discount + '% off — ' + unlocked.min + '+ tier'
        : 'No tier unlocked yet';
      var discountRow = unlocked
        ? '<tr><td>Estimated garment discount</td><td class="screwdriver-summary__qty-cell">−' + bdsBcaFormatCents(discountCents) + '</td></tr>'
        : '';

      // BDS CUSTOM: fee rows appear only when Business Name is selected.
      var feeRows = '';
      var feeCents = 0;
      if (bdsBcaIsBusinessName()) {
        var perPiece = bdsBcaFeeCentsPerPiece(combinedQty);
        feeCents = perPiece * pageQty;
        feeRows =
          '<tr><td>Custom left-chest imprint</td>' +
          '<td class="screwdriver-summary__qty-cell">' + pageQty + ' × ' + bdsBcaFormatCents(perPiece) + ' = ' + bdsBcaFormatCents(feeCents) + '</td></tr>';
      }

      var finalCents = subtotalCents - discountCents + feeCents;

      var maxTierMin = BDS_BCA_TIERS[0].min;

      summaryEl.innerHTML =
        '<h4 class="screwdriver-summary__title" ' +
            'style="font-size:1.6rem;font-weight:700;' +
                   'color:rgba(var(--color-foreground),1);' +
                   'text-transform:none;letter-spacing:normal;' +
                   'margin:0 0 1rem;">Adding to Cart</h4>' +
        '<table class="screwdriver-summary__table">' +
          '<tbody>' + rows + '</tbody>' +
          '<tfoot>' +
            '<tr><td>Garment subtotal</td><td class="screwdriver-summary__qty-cell">' + pageQty + ' ' + (pageQty === 1 ? 'garment' : 'garments') + ' · ' + bdsBcaFormatCents(subtotalCents) + '</td></tr>' +
            '<tr><td>Discount tier</td><td class="screwdriver-summary__qty-cell">' + tierBadgeText + '</td></tr>' +
            discountRow +
            feeRows +
            '<tr class="screwdriver-summary__total-row"><td>Estimated total</td><td class="screwdriver-summary__qty-cell">' + bdsBcaFormatCents(finalCents) + '</td></tr>' +
          '</tfoot>' +
        '</table>' +
        bdsBcaBuildCalloutHtml(unlocked, next, combinedQty, discountCents, cartBcaQty, maxTierMin);

      if (crossNoteEl) crossNoteEl.hidden = false;

      bdsBcaEnforceCustomMin();
    }

    // BDS CUSTOM: PDP enforcement of the 25-per-garment-type custom-imprint minimum.
    //   Rule: when Business Name is selected AND this page's total quantity is 1-24,
    //   disable Add to Cart and show an inline message. If total is 0 → normal empty
    //   state (no message). If Logo is selected OR total >= 25 → button enabled.
    //   Per-page only — per-garment-type combining is done cart-side by the guard.
    //   Called from bdsBcaUpdateSummary() (fires on every size/chest change) and
    //   from bdsBcaSetChestVisibility() indirectly.
    function bdsBcaEnforceCustomMin() {
      var pageQty = bdsBcaGetTotal();
      var custom  = bdsBcaIsBusinessName();
      var short   = custom && pageQty >= 1 && pageQty < customMin;
      if (short) {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
        errorEl.textContent =
          'Custom imprint requires ' + customMin + ' or more of this item — you have ' +
          pageQty + '. Add ' + (customMin - pageQty) + ' more, or choose the logo design.';
        errorEl.style.display = 'block';
      } else {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-disabled');
        errorEl.style.display = 'none';
        errorEl.textContent = '';
      }
    }

    // BDS CUSTOM: Add to Cart — garments always; fee + properties only when Business Name.
    atcBtn.addEventListener('click', function () {
      var pageQty     = bdsBcaGetTotal();
      var combinedQty = pageQty + cartBcaQty;

      if (pageQty === 0) {
        errorEl.textContent = 'Enter at least one quantity';
        errorEl.style.display = 'block';
        return;
      }

      var custom = bdsBcaIsBusinessName();

      if (custom) {
        if (!imprintName || imprintName.value.trim().length === 0) {
          if (imprintErr) imprintErr.hidden = false;
          if (imprintName) imprintName.focus();
          return;
        }
        // BDS CUSTOM: defensive per-page min check — bdsBcaEnforceCustomMin already
        // disables the button live, but if this click still fires (programmatic call,
        // race), enforce the same rule with the same message.
        if (pageQty < customMin) {
          errorEl.textContent =
            'Custom imprint requires ' + customMin + ' or more of this item — you have ' +
            pageQty + '. Add ' + (customMin - pageQty) + ' more, or choose the logo design.';
          errorEl.style.display = 'block';
          return;
        }
      }

      // Build properties for the custom path.
      var properties = null;
      if (custom) {
        properties = { 'Left Chest': 'Business Name' };
        if (imprintName.value.trim())  properties['Business Name'] = imprintName.value.trim();
        if (imprintPhone && imprintPhone.value.trim()) properties['Phone'] = imprintPhone.value.trim();
      }

      var items = [];
      grid.querySelectorAll('.siws-tee-matrix__input').forEach(function (inp) {
        var qty = parseInt(inp.value, 10);
        if (qty > 0) {
          var line = { id: parseInt(inp.dataset.variantId, 10), quantity: qty };
          if (properties) line.properties = properties;
          items.push(line);
        }
      });

      if (custom && feeVariantId) {
        var feeLine = { id: feeVariantId, quantity: pageQty };
        if (properties) feeLine.properties = properties;
        items.push(feeLine);
      }

      atcBtn.disabled    = true;
      atcBtn.textContent = 'Adding…';
      errorEl.style.display = 'none';

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = {
        items: items,
        sections:     cart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'],
        sections_url: window.location.pathname
      };

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(body)
      })
        .then(async function (res) {
          if (!res.ok) {
            var e = await res.json().catch(function () { return {}; });
            throw new Error(e.description || 'Cart add failed');
          }
          var responseData = await res.json();
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bds-bca', cartData: responseData });
          }
          if (cart) {
            cart.renderContents(responseData);
          } else {
            var newBubbleHTML = responseData.sections && responseData.sections['cart-icon-bubble'];
            var liveBubble = document.getElementById('cart-icon-bubble');
            if (newBubbleHTML && liveBubble) {
              var parsed = new DOMParser().parseFromString(newBubbleHTML, 'text/html');
              var inner = parsed.querySelector('.shopify-section');
              if (inner) liveBubble.innerHTML = inner.innerHTML;
            }
          }
          grid.querySelectorAll('.siws-tee-matrix__input').forEach(function (inp) { inp.value = ''; });
          bdsBcaUpdateSummary();
          atcBtn.disabled    = false;
          atcBtn.textContent = 'Add to Cart';
        })
        .catch(function (err) {
          atcBtn.disabled    = false;
          atcBtn.textContent = 'Add to Cart';
          errorEl.textContent = err.message || 'Something went wrong — please try again.';
          errorEl.style.display = 'block';
        });
    });

    bdsBcaSetChestVisibility();
    bdsBcaUpdateSummary();

    if (bcaProductIds && bcaProductIds.length) {
      bdsBcaFetchCartQty(bcaProductIds).then(function (qty) {
        cartBcaQty = qty;
        bdsBcaUpdateSummary();
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          bdsBcaFetchCartQty(bcaProductIds).then(function (qty) {
            cartBcaQty = qty;
            bdsBcaUpdateSummary();
          });
        });
      }
    }
  });
})();
